import React, { useMemo } from 'react'
import {
  Box, Text,
} from '@usap/uicomponents'
import { commaSeparetedValue } from '@usap/core'

const CouponDiscount = props => {
  const { data } = props
  const { summary } = data

  const style = useMemo(
    () => ({
      wrapper: { position: 'relative' },
      amount: {
        color: '#669944',
        fontWeight: 'bold',
      },
    }),
    [],
  )

  let discount = 0
  if (summary.coupon.discount) {
    discount = parseFloat(summary.coupon.discount)
  }

  return (
    <Box direction="row" justify="between" style={style.wrapper}>
      <Text size="small">
        Coupon:
      </Text>

      <Text size="small" style={style.amount} data-testid="cart-summary-discount">
        -$
        {commaSeparetedValue(discount)}
      </Text>
    </Box>
  )
}

export default CouponDiscount
